export enum FinishSurveyStatus {
    NotVerified = 'NotVerified',
    NotCompleted = 'NotCompleted',
    Completed = 'Completed',
}
